jQuery(document).ready(function ($) {
  $(".c-category-list__item").hover(
    function () {
      var $this = $(this);
      //Remove class from siblings
      $this.siblings().find(".c-category-list__panel").removeClass("is-active");

      // Toggle the item
      $this.find(".c-category-list__panel").addClass("is-active");
    },
    function () {
      var $this = $(this);
      $this.find(".c-category-list__panel").removeClass("is-active");
    }
  );
});
